module.exports = __webpack_public_path__ + "media/images/front/img_pd01-d49fb0297af89bb478ad07859edd1b4b.jpg";